import PropTypes from "prop-types";
import GuidedSearchBoard from "../../../../../../../../../features/browse-search/components/GuidedSearchBoard";
import BaseSearchPage from "../../../SearchPage";

export const SearchPage = ({ formatTranslation, location }) => (
  <BaseSearchPage
    formatTranslation={formatTranslation}
    location={location}
    topContent={<GuidedSearchBoard />}
  />
);

SearchPage.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  location: PropTypes.object,
};

export default SearchPage;
